import { render, staticRenderFns } from "./Questionari.vue?vue&type=template&id=76c30b04&"
import script from "./Questionari.vue?vue&type=script&lang=js&"
export * from "./Questionari.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports